import { currentLocale } from '../../i18n'

// Planilla column types, in the backend's spelling (models.AtributoTipo).
// Kept out of the component files so React fast refresh keeps working there.
export const TIPOS = ['texto', 'numero', 'fecha', 'estado', 'persona', 'archivo']
export const TIPO_ICON = { texto: 'Aa', numero: '#', fecha: '📅', estado: '▾', persona: '👤', archivo: '📎' }

// A people cell stores the people's ids as JSON ("[12, 15]"); [] if empty or unreadable.
export function idsPersona(valor) {
  if (valor == null || valor === '') return []
  try { const v = JSON.parse(valor); return (Array.isArray(v) ? v : [v]).map(Number).filter(Number.isFinite) }
  catch { return [] }
}

// Colors an estado option may take. Names and order match COLORES in
// backend/unidad_atributos.py (which validates them and fills the Excel).
// Full class strings, written out, so Tailwind keeps them in the build.
export const COLORES = {
  gris:     { pill: 'bg-gray-100 text-gray-700',     dot: 'bg-gray-400' },
  rojo:     { pill: 'bg-red-100 text-red-800',       dot: 'bg-red-500' },
  naranjo:  { pill: 'bg-orange-100 text-orange-800', dot: 'bg-orange-500' },
  ambar:    { pill: 'bg-amber-100 text-amber-800',   dot: 'bg-amber-500' },
  amarillo: { pill: 'bg-yellow-100 text-yellow-800', dot: 'bg-yellow-400' },
  lima:     { pill: 'bg-lime-100 text-lime-800',     dot: 'bg-lime-500' },
  verde:    { pill: 'bg-green-100 text-green-800',   dot: 'bg-green-500' },
  turquesa: { pill: 'bg-teal-100 text-teal-800',     dot: 'bg-teal-500' },
  celeste:  { pill: 'bg-sky-100 text-sky-800',       dot: 'bg-sky-500' },
  azul:     { pill: 'bg-blue-100 text-blue-800',     dot: 'bg-blue-500' },
  indigo:   { pill: 'bg-indigo-100 text-indigo-800', dot: 'bg-indigo-500' },
  violeta:  { pill: 'bg-violet-100 text-violet-800', dot: 'bg-violet-500' },
  rosado:   { pill: 'bg-pink-100 text-pink-800',     dot: 'bg-pink-500' },
}

// Automatic colors for options nobody coloured by hand. Same rules as
// color_de in backend/unidades_excel.py, so the Excel matches the screen.
const AUTO = [
  ['verde', /^(listo|instalad|activad|ok$|operativ|reparad|buen)/i],
  ['rojo', /^(no instalad|falla|detenid|malo|f\/s)/i],
  ['ambar', /(definir|pendiente|en proceso|trabajando|revisar|rutear)/i],
  ['gris', /^(n\/a|no requerido|no revisado|no aplica)/i],
]
const CICLO = ['azul', 'violeta', 'turquesa', 'rosado', 'naranjo', 'indigo', 'lima', 'celeste', 'amarillo']

// The color name an option of `columna` shows: chosen by hand, else automatic.
export function colorDe(columna, opcion) {
  const elegido = columna?.colores?.[opcion]
  if (elegido && COLORES[elegido]) return elegido
  const auto = AUTO.find(([, rx]) => rx.test(opcion))
  if (auto) return auto[0]
  const opciones = columna?.opciones || []
  const i = opciones.includes(opcion) ? opciones.indexOf(opcion) : opcion.length
  return CICLO[i % CICLO.length]
}

// A record's cells and files under a renamed column's new name.
export function moverClave(registro, de, a) {
  const mover = (obj) => {
    if (!obj || !(de in obj)) return obj
    const { [de]: v, ...resto } = obj
    return { ...resto, [a]: v }
  }
  return { ...registro, atributos: mover(registro.atributos), archivos: mover(registro.archivos) }
}

// Server timestamps are UTC without a zone ("2026-09-26T14:05:00"); read
// bare, the browser would take them as local time and be 3 hours off in
// Chile. Same fix as Settings.jsx's expires_at.
export function fechaUtc(iso) {
  if (!iso) return null
  return new Date(/[zZ]|[+-]\d\d:\d\d$/.test(iso) ? iso : `${iso}Z`)
}

export function formatFechaHora(iso) {
  const d = fechaUtc(iso)
  return d ? d.toLocaleString(currentLocale(), { dateStyle: 'medium', timeStyle: 'short' }) : ''
}

export function formatFecha(iso) {
  if (!iso) return ''
  const [y, m, d] = iso.split('-').map(Number)
  // Built from parts: new Date(iso) would read UTC midnight and show the
  // previous day in Chile.
  return new Date(y, m - 1, d).toLocaleDateString(currentLocale())
}
